import { appstr } from "./appstr";

export const createBoldToastMessage = (
  templateStr: string,
  replacements?: Record<string, string>
) => {
  // Automatically make all replacement values bold
  const formatConfig =
    replacements &&
    Object.keys(replacements).reduce(
      (config, key) => {
        config[key] = { type: "bold" };
        return config;
      },
      {} as Record<string, { type: "bold" }>
    );

  return {
    message: appstr(templateStr, replacements),
    alertProps: {
      template: appstr(templateStr),
      replaceDict: replacements,
      formatConfig
    }
  };
};
